const ITEMS = [
  "100+ Years of Heritage",
  "Full IKEA Kitchen",
  "Secluded Outdoor Shower",
  "Sleeps 6",
  "Private Deck & BBQ",
  "300 Steps to Connaught Beach",
  "Car-Free Summers",
  "Washer & Dryer",
  "High-Speed Wi-Fi",
  "Wood Fireplace",
  "Wild Berries in Season",
];

export default function Marquee() {
  return (
    <section
      data-testid="marquee-ribbon"
      className="marquee-paused overflow-hidden border-y border-[#1E3323]/10 bg-[#E8E2D7] py-5"
    >
      <div className="animate-marquee flex w-max whitespace-nowrap will-change-transform">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex shrink-0 items-center" aria-hidden={copy === 1}>
            {ITEMS.map((item, i) => (
              <span key={`${copy}-${i}`} className="flex items-center">
                <span className="px-6 font-serif text-lg italic text-[#1E3323]/85 sm:text-xl">
                  {item}
                </span>
                <span className="h-1.5 w-1.5 rounded-full bg-[#C8634B]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
